import { type FC, memo } from 'react';
import { useStepperContext } from '@components/stepper';
import ProductDetailsStep from './product-details-step';
import ProductRouteStep from './product-route-step';
import CapacityStep from './capacity-step';
import ScheduleStep from './schedule-step';
import FinancingStep from './financing-step';
import OptionsStep from './options-step';
import PreviewStep from './preview-step';
import ProductConfigurationStep from './product-configuration-step';

export interface StepsProps {}

const Steps: FC<StepsProps> = () => {
    const { activeIndex, steps } = useStepperContext();
    const activeStep = steps[activeIndex];

    return (
        <>
            {activeStep.value === 'configuration' && (
                <ProductConfigurationStep />
            )}
            {activeStep.value === 'product-details' && <ProductDetailsStep />}
            {activeStep.value === 'route' && <ProductRouteStep />}
            {activeStep.value === 'capacity' && <CapacityStep />}
            {activeStep.value === 'schedule' && <ScheduleStep />}
            {activeStep.value === 'financial-information' && <FinancingStep />}
            {activeStep.value === 'product-options' && <OptionsStep />}
            {activeStep.value === 'preview' && <PreviewStep />}
        </>
    );
};

export default memo(Steps);
